import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DropdownMenuWithIconsService } from '@shared/dropdown-menu-with-icons/dropdown-menu-with-icons.service';
import { AvatarShapes } from 'mojo-avatar';
import { Elevations } from 'mojo-card';
import { MojoPrivilegesService } from 'mojo-privileges';
import { Observable } from 'rxjs';
import {
  CandidatesConfig,
  CandidatesPrivileges,
} from '@modules/candidates/candidates.abstract.config';
import { CandidateAdapter } from '@shared';
import { AtsButtonType } from '@shared/ats-button/ats-button.type';

import { ComponentsPrivileges } from '../components.abstract.config';
import { DropdownMenuItem } from 'mojo-abstract-dropdown-menu';

@Component({
  selector: 'mojo-candidate-profile-card',
  templateUrl: './candidate-profile-card.component.html',
  styleUrls: ['./candidate-profile-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateProfileCardComponent implements OnChanges {
  @Input() candidate: CandidateAdapter;
  @Input() privileges: ComponentsPrivileges;

  menuItems: DropdownMenuItem[] = [
    this.dropdownMenuWithIconsService.getMoveForwardForAnyJob(),
    this.dropdownMenuWithIconsService.getInviteToApplyForAnyJob(),
    this.dropdownMenuWithIconsService.getAddAsProspectForAnyJob(),
    this.dropdownMenuWithIconsService.getAddToTalentPoolForAnyJob(),
  ];

  avatarContent: {
    imageId: number;
    initials: string;
    photoShape: AvatarShapes;
  };

  textContent: {
    header: string;
    subHeader?: string;
    subHeaderTwo?: string;
    firstRow?: string;
    secondRow?: string;
    thirdRowSpaced?: string;
  };

  isFullBadges$: Observable<boolean> = this.privilegesService.hasPrivilege(
    this.candidatesConfig.privileges.candidates.fullBadges,
  );

  candidateAtsButtonType = AtsButtonType.CANDIDATE;
  elevation = Elevations.first;
  avatarPhotoShape = AvatarShapes.circle;
  candidatePrivileges: CandidatesPrivileges;

  constructor(
    private candidatesConfig: CandidatesConfig,
    private privilegesService: MojoPrivilegesService,
    private dropdownMenuWithIconsService: DropdownMenuWithIconsService,
  ) {
    this.candidatePrivileges = this.candidatesConfig.privileges;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes.candidate && changes.candidate.previousValue !== changes.candidate.currentValue) {
      this.avatarContent = {
        imageId: changes.candidate.currentValue.candidateImageId,
        initials: changes.candidate.currentValue.initials,
        photoShape: AvatarShapes.circle,
      };

      this.textContent = {
        header: changes.candidate.currentValue.visibleName,
        subHeader: changes.candidate.currentValue.currentJobTitle
          ? changes.candidate.currentValue.currentJobTitle
          : undefined,
        subHeaderTwo: !!changes.candidate.currentValue.experience?.employerName
          ? changes.candidate.currentValue.experience?.employerName
          : '',
        firstRow:
          !!changes.candidate.currentValue.experiences &&
          changes.candidate.currentValue.experiences[0]
            ? changes.candidate.currentValue.experiences[0].period
            : undefined,
        secondRow:
          !!changes.candidate.currentValue.experienceYears &&
          changes.candidate.currentValue.experienceYears > 0
            ? changes.candidate.currentValue.experienceYears + ' years of experience'
            : undefined,
        thirdRowSpaced: changes.candidate.currentValue.addressLong,
      };
    }
  }
}
